import { render, staticRenderFns } from "./GuppyChatSidebarFooter.vue?vue&type=template&id=38961077&scoped=true&"
import script from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebarFooter.vue?vue&type=style&index=0&id=38961077&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38961077",
  null
  
)

export default component.exports